import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	priorityLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.create-work-item.card-title',
		defaultMessage: 'Create plan work item',
		description: 'Title for the create plan work item action card',
	},
	spaceLabel: {
		id: 'conversation-assistant-message-actions.create-work-item.space-label',
		defaultMessage: 'Space',
		description: 'Label for the space field in the create work item form',
	},
	priorityLabel: {
		id: 'conversation-assistant-message-actions.create-work-item.priority-label',
		defaultMessage: 'Priority',
		description: 'Label for the priority field in the create work item form',
	},
	assigneeLabel: {
		id: 'conversation-assistant-message-actions.create-work-item.assignee-label',
		defaultMessage: 'Assignee',
		description: 'Label for the assignee field in the create work item form',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.create-work-item.confirm-button',
		defaultMessage: 'Create',
		description:
			'Text on the confirm button in the Jira Plans create work item dialog. Clicking it submits the form and creates the new work item in the plan',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.create-work-item.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text on the cancel button in the Jira Plans create work item dialog. Dismisses the dialog without creating a work item',
	},
});

export default messages;
